import { useCallback, useMemo } from 'react'
import { useViewActions, useViewNavigation } from '@renderer/overlay/Sidepanel/view-atoms'
import { viewChrome } from '../../view-registry'
import { AmplitudeRenderer } from '@renderer/utils/amplitude.renderer'
import { SidepanelHeaderNavButton } from './sidepanel-header-nav-button'

export function SidepanelHeaderForwardButton() {
  const { forwardView } = useViewActions()
  const { nextForwardView, forwardTrail, canGoForward } = useViewNavigation()

  const tooltipText = useMemo(() => {
    const label = nextForwardView && viewChrome(nextForwardView)?.label
    return label ? `Forward to ${label}` : 'Forward'
  }, [nextForwardView])

  const handleForward = useCallback(() => {
    forwardView()
    AmplitudeRenderer.trackEvent('Sidepanel Header', {
      action: 'forward view',
      toView: nextForwardView?.id,
    })
  }, [forwardView, nextForwardView])

  return (
    <SidepanelHeaderNavButton
      direction="forward"
      trail={forwardTrail}
      disabled={!canGoForward}
      onNavigate={handleForward}
      tooltip={tooltipText}
    />
  )
}
